import Dialog from '@mui/material/Dialog';
import {
  Grid,
  Paper,
  DialogTitle,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Draggable from 'react-draggable';
import AddDevice from './AddDevice';

export const AddDeviceModal = ({
  user,
  merchantId,
  merchantName,
  gateways,
  isOpen,
  onClose,
}) => {
  const renderContent = () => {
    return (
      <>
        <Grid item textAlign="initial" xs={12}>
          <AddDevice
            user={user}
            merchantId={merchantId}
            merchantName={merchantName}
            gateways={gateways}
            onClose={onClose}
          />
        </Grid>
      </>
    );
  };

  const PaperComponent = (props) => {
    return (
      <Draggable
        handle="#add-device-modal-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="add-device-modal-title"
        aria-describedby="add-device-modal-description"
        PaperComponent={PaperComponent}
      >
        <DialogTitle
          id="add-device-modal-title"
          style={{ cursor: 'move' }}
          sx={{
            typography: 'h4', color: 'textPrimary',
          }}
        >
          Add Device
        </DialogTitle>
        <DialogContent>
          {renderContent()}
        </DialogContent>
      </Dialog>
    </>
  );
};
